/**
 * @desc This page applies 508 Compliance standards on table element
 *
 * @prettier
 * @author Alexander Nagelberg
 * @author Victoria Saleem (minor updates)
 */
import React from 'react'
import { useParams } from 'react-router-dom'

import LgyLink from 'app/components/util/lgy-link/LgyLink'
import { formatUnixDateStringToDisplayString } from 'app/utils/dateTimeUtils'
import { URLs } from '../utils/refundUtils'

const RefundNotesTable = ({ notes, isAffiliate }) => {
  const { id: refundId } = useParams()

  return (
    <div className='lgy-funding-fee-refund-notes-table'>
      <table aria-label='Notes Table'>
        <caption>Refund Notes Table</caption>
        <thead>
          <tr>
            <th scope='col' id='created on'>
              Created On
            </th>
            <th scope='col' id='created by'>
              Created By
            </th>
            <th scope='col' id='title'>
              Title
            </th>
          </tr>
        </thead>
        <tbody>
          {notes?.map(({ id, creationDate, author, title }) => (
            <tr key={id}>
              <td headers='created on'>{formatUnixDateStringToDisplayString(creationDate)}</td>
              <td headers='created by'>{author}</td>
              <td headers='title'>
                <LgyLink to={`${URLs.FUNDING_FEE_REFUND_APP_PATH}/${refundId}/note/${id}`}>{title}</LgyLink>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

export default RefundNotesTable
